import { useEffect, useState } from 'react'
import HelpIcon from '@mui/icons-material/Help'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Fab } from 'settle-ui/components/Fab/Fab'
import { useIntercomAvailable } from 'lib/hooks/useIntercomAvailable/useIntercomAvailable'

export const INTERCOM_CUSTOM_LAUNCHER_ID = 'intercom-custom-launcher'

/**
 * Custom Intercom launcher component that replaces the default Intercom launcher.
 *
 * @remarks
 * For custom launcher support:
 * - Default launcher is disabled in "Show the Messenger Launcher" section at
 *   https://app.intercom.com/a/apps/iw6t9xkk/settings/channels/messenger/web?section=launcher&tab=content
 *
 * - Custom launcher is configured in "Other Settings" section at
 *   https://app.segment.com/settle/destinations/intercom/sources/javascript/instances/62c87a9d02e83e0836a6dbeb/configuration
 */
export const IntercomCustomLauncherFab: React.FC = () => {
  const isIntercomAvailable = useIntercomAvailable()

  const [isChatShown, setChatShown] = useState(false)

  useEffect(() => {
    if (!isIntercomAvailable) {
      return
    }

    window.Intercom('onShow', () => setChatShown(true))
    window.Intercom('onHide', () => setChatShown(false))
  }, [isIntercomAvailable])

  if (!isIntercomAvailable) {
    return null
  }

  return <Fab id={INTERCOM_CUSTOM_LAUNCHER_ID} icon={isChatShown ? <ExpandMoreIcon /> : <HelpIcon />} />
}
